import React, { Component } from 'react'
import { Card, Form, Col } from 'react-bootstrap'
import Autosuggest from 'react-autosuggest';
import { CodingWorksheetService } from '../../services';
import { modalActionCreator, spinnerActionCreator } from '../../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class WorksheetICD10Diag extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {suggestions: [], value: '', lastSearch: ''}

        this.renderControl = this.renderControl.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.onLocalChange = this.onLocalChange.bind(this);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    }

    renderSuggestion = suggestion => (
        <div>
            {suggestion.icdCode + ' - ' + suggestion.description}
        </div>
    );

    //getSuggestionValue = suggestion => suggestion.icdCode;

    getSuggestionValue(suggestion) {
        return suggestion.icdCode + ' - ' + suggestion.description;
    }

    onLocalChange = (event, { newValue }) => {
        let localEvent = { ...event };
        localEvent.target.name = this.props.name;
        localEvent.target.value = newValue;
        this.props.onChangeInput(localEvent);
        this.setState({ 
            value: newValue
        });
    };

    async getSuggestions(value, reason) {
        if (reason === 'input-changed') {
            const inputValue = value.trim().toLowerCase();
            const inputLength = inputValue.length;

            if (this.state.lastSearch !== inputValue && inputLength > 2) {

                //hide the spinner for this
                this.props.overrideSpinner();

                const worksheetService = new CodingWorksheetService();
                let callResult = await worksheetService.searchIcd10Codes(inputValue);
                if (callResult.result) {
                    this.setState({ suggestions: callResult.model, lastSearch: inputValue });
                }

            }
        }
    };

    onSuggestionsFetchRequested = async ({ value, reason }) => {
        //this.setState({
        //    suggestions: this.getSuggestions(value)
        //});
        await this.getSuggestions(value, reason);
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    renderControl() {
        let lg = this.props.colLg ? this.props.colLg : 9;
        let md = this.props.colMd ? this.props.colMd : 12;
        let value = this.props.value ? this.props.value : '';
        let suggestions = this.state.suggestions;
        if (this.props.print) {
            if (this.props.value !== undefined && this.props.value !== null && this.props.value !== '')
                return (
                    <Form.Group as={Col} lg={lg} md={md}>
                        <Form.Label>{this.props.label}</Form.Label><br/>
                        {this.props.value}
                    </Form.Group>
                );
        } else {
            const inputProps = {
                placeholder: 'Search ICD10 codes...',
                value,
                onChange: this.onLocalChange
            };
            return (
                <Form.Group as={Col} lg={lg} md={md}>
                    <Form.Label>{this.props.label}</Form.Label>
                    <Autosuggest
                        id={this.props.name}
                        name={this.props.name}
                        suggestions={this.state.suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        inputProps={inputProps} />
                    <Form.Text className="text-muted">{this.props.description}</Form.Text>
                    <Form.Control.Feedback type="invalid">
                        Initial and Revised values cannot be the same.
                    </Form.Control.Feedback>
                </Form.Group>
            );
        }
    }

    render() {
        return (
            <>{ this.renderControl() }</>
        );
    }
}

export default connect(null, dispatch => bindActionCreators(spinnerActionCreator, dispatch))(WorksheetICD10Diag);
//export default WorksheetICD10Diag

//const WorksheetICD10Diag = (props) => {
//    let lg = props.colLg ? props.colLg : 9;
//    let md = props.colMd ? props.colMd : 12;

//    const renderSuggestion = suggestion => (
//        <div>
//            {suggestion.icdCode + ' - ' + suggestion.description}
//        </div>
//    );

//    const getSuggestionValue = suggestion => suggestion.icdCode + ' - ' + suggestion.description;

//    if (props.print) {
//        return (
//            <Form.Group as={Col} lg={lg} md={md}>
//                <Form.Label>{props.label}</Form.Label>
//                {props.value}
//            </Form.Group>
//        );
//    } else {
//        return (
//            <Form.Group as={Col} lg={lg} md={md}>
//                <Form.Label>{props.label}</Form.Label>
//                {
//                    //<Form.Control as="select"
//                    //    value={props.value}
//                    //    name={props.name}
//                    //    id={props.name}
//                    //    onChange={props.onChangeInput}
//                    //    onBlur={props.onBlur}
//                    //    isInvalid={props.error}>
//                    //    <option key={null} value={0}>Select {props.label}...</option>
//                    //</Form.Control>
//                }
//                <Autosuggest
//                    suggestions={suggestions}
//                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
//                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
//                    getSuggestionValue={getSuggestionValue}
//                    renderSuggestion={renderSuggestion}
//                    inputProps={inputProps}
//                />
//                <Form.Control.Feedback type="invalid">
//                    Initial and Revised values cannot be the same.
//                </Form.Control.Feedback>
//            </Form.Group>
//        );
//    }
//}
